'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: ', 'px;\n  min-height: ', 'px;\n  box-sizing: inherit;\n  -moz-box-sizing: inherit;\n  -webkit-box-sizing: inherit;\n  display: table-cell;\n  vertical-align: top;\n  word-break: break-all;\n'], ['\n  width: ', 'px;\n  min-height: ', 'px;\n  box-sizing: inherit;\n  -moz-box-sizing: inherit;\n  -webkit-box-sizing: inherit;\n  display: table-cell;\n  vertical-align: top;\n  word-break: break-all;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n'], ['\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var OuterContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.cellWidth;
}, function (props) {
  return props.rowHeight;
});

var InnerContainer = _styledComponents2.default.div(_templateObject2);

var DivCell = function (_React$Component) {
  _inherits(DivCell, _React$Component);

  function DivCell() {
    _classCallCheck(this, DivCell);

    return _possibleConstructorReturn(this, (DivCell.__proto__ || Object.getPrototypeOf(DivCell)).apply(this, arguments));
  }

  _createClass(DivCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outerStyle = _props.outerStyle,
          style = _props.style,
          rowHeight = _props.rowHeight,
          cellWidth = _props.cellWidth,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['outerStyle', 'style', 'rowHeight', 'cellWidth', 'children']);

      return React.createElement(OuterContainer, _extends({
        style: outerStyle,
        cellWidth: cellWidth,
        rowHeight: rowHeight
      }, rest), React.createElement(InnerContainer, {
        style: style
      }, children));
    }
  }]);

  return DivCell;
}(React.Component);

DivCell.displayName = 'DivCell';
exports.default = DivCell;